import { SpdrClientViewModel } from "../ViewModel/SpdrClientViewModel";
import { ProjectStateType } from "./EditProjectContext";
import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";
import { updateSpdrFTLIdentifier } from "./LeftSide/UpdateSpdrFTLIdentifier";

export const setSpdrsOnThisRoute = (
  routeId: number,
  items: Array<SpdrClientViewModel>,
  { project, setProject }: ProjectStateType
) => {
  const updateFtlRoute = (ftlRouteItem: FtlRouteViewModel) => {
    return ftlRouteItem.RouteId === routeId
      ? {
          ...ftlRouteItem,
          SpdrsOnThisRoute: items,
        }
      : ftlRouteItem;
  };

  setProject(
    updateSpdrFTLIdentifier({
      ...project,
      FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
    })
  );
};
